import { alpha } from '@mui/material/styles';
import { toggleButtonClasses } from '@mui/material/ToggleButton';

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

// ----------------------------------------------------------------------

export function toggleButton(theme) {
  const rootStyles = ownerState => {
    const defaultStyle = {
      [`&.${toggleButtonClasses.selected}`]: {
        backgroundColor: theme.palette.background.primaryWhite1,
        borderRadius: '0px',
        borderColor: 'currentColor',
        boxShadow: '0 0 0 0.5px currentColor',
      },
    };

    const colorStyle = COLORS.map(color => ({
      ...(ownerState.color === color && {
        '&:hover': {
          borderColor: alpha(theme.palette[color].main, 0.48),
          backgroundColor: alpha(
            theme.palette[color].main,
            theme.palette.action.hoverOpacity,
          ),
        },
      }),
    }));

    const disabledState = {
      [`&.${toggleButtonClasses.disabled}`]: {
        [`&.${toggleButtonClasses.selected}`]: {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected,
          borderColor: theme.palette.action.disabledBackground,
        },
      },
    };

    return [defaultStyle, ...colorStyle, disabledState];
  };

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState }) => rootStyles(ownerState),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          backgroundColor: theme.palette.background.primaryGrey1,
          border: `solid 1px ${theme.palette.border.primaryBlack3}`,
        },
        grouped: {
          [`&.${toggleButtonClasses.selected}`]: {
            boxShadow: 'none',
            color: theme.palette.content.accent1,
          },
          '&:not(:first-of-type), &:not(:last-of-type)': {
            paddingLeft: '17px',
            paddingRight: '17px',
            paddingTop: '29px',
            paddingBottom: '29px',
            borderRadius: '0px',
            borderColor: 'transparent',
          },
        },
      },
    },
  };
}
